import { render, staticRenderFns } from "./ChooseUserField.vue?vue&type=template&id=7c4fba2d"
import script from "./ChooseUserField.vue?vue&type=script&lang=js"
export * from "./ChooseUserField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports